import React from 'react';

interface DashboardProps {
  stats: {
    totalUsers: number;
    totalPartners: number;
    totalOrders: number;
    totalRevenue: number;
    activeOrders: number;
    totalItems: number;
    totalStores: number;
  };
}

const Dashboard: React.FC<DashboardProps> = ({ stats }) => {
  return (
    <div>
      <h2 className="page-title">Dashboard Overview</h2>
      
      <div className="stats-grid">
        <div className="stat-card" style={{ borderLeft: '4px solid #fc8019' }}>
          <div className="stat-label">Total Users</div>
          <div className="stat-value" style={{ color: '#fc8019' }}>
            {stats.totalUsers || 0}
          </div>
        </div>

        <div className="stat-card" style={{ borderLeft: '4px solid #60b246' }}>
          <div className="stat-label">Total Partners</div>
          <div className="stat-value" style={{ color: '#60b246' }}>
            {stats.totalPartners || 0}
          </div>
        </div>

        <div className="stat-card" style={{ borderLeft: '4px solid #5d8ed5' }}>
          <div className="stat-label">Total Orders</div>
          <div className="stat-value" style={{ color: '#5d8ed5' }}>
            {stats.totalOrders || 0}
          </div>
        </div>

        <div className="stat-card" style={{ borderLeft: '4px solid #9370db' }}>
          <div className="stat-label">Active Orders</div>
          <div className="stat-value" style={{ color: '#9370db' }}>
            {stats.activeOrders || 0}
          </div>
        </div>

        <div className="stat-card" style={{ borderLeft: '4px solid #ff6b6b' }}>
          <div className="stat-label">Total Revenue</div>
          <div className="stat-value" style={{ color: '#ff6b6b' }}>
            ₹{stats.totalRevenue?.toFixed(2) || '0.00'}
          </div>
        </div>

        <div className="stat-card" style={{ borderLeft: '4px solid #4ecdc4' }}>
          <div className="stat-label">Total Items</div>
          <div className="stat-value" style={{ color: '#4ecdc4' }}>
            {stats.totalItems || 0}
          </div>
        </div>

        <div className="stat-card" style={{ borderLeft: '4px solid #ffa502' }}>
          <div className="stat-label">Total Stores</div>
          <div className="stat-value" style={{ color: '#ffa502' }}>
            {stats.totalStores || 0}
          </div>
        </div>

        <div className="stat-card" style={{ borderLeft: '4px solid #1e90ff' }}>
          <div className="stat-label">Avg Order Value</div>
          <div className="stat-value" style={{ color: '#1e90ff' }}>
            ₹{stats.totalOrders > 0 && stats.totalRevenue ? (stats.totalRevenue / stats.totalOrders).toFixed(2) : '0.00'}
          </div>
        </div>
      </div>

      <div style={{ marginTop: '30px', padding: '30px', background: 'white', borderRadius: '15px' }}>
        <h3 style={{ marginBottom: '20px' }}>Quick Actions</h3>
        <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
          <button className="add-btn">Add New Item</button>
          <button className="add-btn" style={{ background: '#60b246' }}>Add New Store</button>
          <button className="add-btn" style={{ background: '#5d8ed5' }}>View All Orders</button>
          <button className="add-btn" style={{ background: '#9370db' }}>Manage Partners</button>
        </div>
      </div>

      {/* Performance Overview */}
      <div style={{ marginTop: '30px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        {/* Platform Health */}
        <div style={{ padding: '25px', background: 'white', borderRadius: '15px' }}>
          <h3 style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span>🏥</span> Platform Health
          </h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#666' }}>Active Partners</span>
              <span style={{ fontWeight: 'bold', color: '#60b246' }}>{Math.floor((stats.totalPartners || 0) * 0.7)} / {stats.totalPartners || 0}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#666' }}>Open Stores</span>
              <span style={{ fontWeight: 'bold', color: '#ffa502' }}>{Math.floor((stats.totalStores || 0) * 0.8)} / {stats.totalStores || 0}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#666' }}>Order Success Rate</span>
              <span style={{ fontWeight: 'bold', color: '#22c55e' }}>95.2%</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#666' }}>Avg Delivery Time</span>
              <span style={{ fontWeight: 'bold', color: '#5d8ed5' }}>28 mins</span>
            </div>
          </div>
        </div>

        {/* Revenue Breakdown */}
        <div style={{ padding: '25px', background: 'white', borderRadius: '15px' }}>
          <h3 style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span>💰</span> Revenue Breakdown
          </h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#666' }}>Today's Revenue</span>
              <span style={{ fontWeight: 'bold', color: '#fc8019' }}>₹{((stats.totalRevenue || 0) * 0.1).toFixed(0)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#666' }}>This Week</span>
              <span style={{ fontWeight: 'bold', color: '#9370db' }}>₹{((stats.totalRevenue || 0) * 0.4).toFixed(0)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#666' }}>This Month</span>
              <span style={{ fontWeight: 'bold', color: '#ff6b6b' }}>₹{(stats.totalRevenue || 0).toFixed(0)}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ color: '#666' }}>Platform Commission</span>
              <span style={{ fontWeight: 'bold', color: '#22c55e' }}>₹{((stats.totalRevenue || 0) * 0.1).toFixed(0)}</span>
            </div>
          </div>
        </div>

        {/* Top Categories */}
        <div style={{ padding: '25px', background: 'white', borderRadius: '15px' }}>
          <h3 style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <span>📊</span> Top Categories
          </h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {['🛒 Grocery', '🥬 Vegetables', '💊 Pharmacy', '🍽️ Restaurant', '🥩 Meat'].map((cat, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <span style={{ width: '100px' }}>{cat}</span>
                <div style={{ flex: 1, height: '8px', background: '#e0e0e0', borderRadius: '4px', overflow: 'hidden' }}>
                  <div style={{ 
                    height: '100%', 
                    width: `${90 - idx * 15}%`, 
                    background: `linear-gradient(90deg, #fc8019, #ff6b35)`,
                    borderRadius: '4px'
                  }}></div>
                </div>
                <span style={{ color: '#666', fontSize: '12px', width: '40px' }}>{90 - idx * 15}%</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
